export const ADD_ARTIST = 'ADD_ARTIST';
export const ENTER_ARTIST = 'ENTER_ARTIST';
export const SUBMIT_ARTIST = 'SUBMIT_ARTIST';
export const ERROR = 'ERROR';
export const LOADING = 'LOADING';
export const ADD_SCORE = 'ADD_SCORE';
export const ANSWER_QUESTION1 = 'ANSWER_QUESTION1';
export const ANSWER_QUESTION2 = 'ANSWER_QUESTION2';
export const ANSWER_QUESTION3 = 'ANSWER_QUESTION3';
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_CLOSE = 'MODAL_CLOSE';


